<div class="program-date card">
  <h4>{{ programNode?.labelText }}</h4>
  <span
    class="label-highlight"
    *ngIf="programNode?.description"
    [innerHTML]="programNode?.description"
  ></span>
  <div class="program-date__input-container">
    @if(type === 'time') {
    <input
      placeholder="--:--"
      inputmode="numeric"
      maxlength="5"
      (input)="onTimeInput($event)"
      pattern="^([01]\d|2[0-3]):([0-5]\d)$"
      [formControl]="formControl"
      class="field__input"
    />
    } @else {
    <input [type]="type" [formControl]="formControl" class="field__input" />

    }
  </div>
</div>
